import React from "react";
import { Layout, Table, Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import languages from "../../constants/languages";
import { getUsers } from "../../services/user";
import { toast } from "react-toastify";

const User = (props) => {
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    getUsers().then((res) => {
      if (res.status === 1) {
        setData(res.data);
      } else {
        toast.error(res.message);
      }
    });

    return () => {
      setData(null);
    };
  }, []);
  const onClickCreate = () => {
    props.history.push(`${process.env.PUBLIC_URL}/user/create`);
  };

  const onClickEditUser = (record) => {
    props.history.push(`${process.env.PUBLIC_URL}/user/detail/${record._id}`);
  };

  const columns = [
    {
      title: languages.titleColumnUserName,
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 2,
      },
      width: "30%",
      showSorterTooltip: false,
    },
    {
      title: languages.formUserLogin,
      dataIndex: "login",
      key: "login",
      width: "30%",
      sorter: {
        compare: (a, b) => a.login.localeCompare(b.login),
        multiple: 2,
      },
      showSorterTooltip: false,
    },
    {
      title: "メモ",
      dataIndex: "note",
      key: "note",
      width: "30%",
    },
    {
      title: "",
      key: "status",
      render: (record) => (
        <Button
          type="primary"
          className="tbl-btn"
          onClick={() => onClickEditUser(record)}
        >
          {languages.btnEditUser}
        </Button>
      ),
    },
  ];

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Layout className="layout-server">
      <Card title={languages.titleUser} className="flex-1">
        <div className="row justify-end">
          <Button
            icon={<PlusOutlined />}
            className="btn-success"
            type="primary"
            onClick={onClickCreate}
          >
            {languages.btnAddUser}
          </Button>
        </div>
        <Table
          dataSource={data}
          columns={columns}
          bordered={true}
          rowKey={"_id"}
          pagination={false}
        />
      </Card>
    </Layout>
  );
};

export default User;
